if (!customElements.get('collapsible-tab')) {
	class CollapsibleTab extends HTMLElement {
		constructor() {
			super()
		}

		connectedCallback() {
			this.init()
		}

		disconnectedCallback() {
			this.destroy()
		}

	init() {
		const destroy = this.dataset.destroy === 'true'
		if (destroy) return

		this.setDefaultData();
		this.attachEvents()
		this.attachResizeListener()

	if (this.getAttribute('open') === 'true') {
		this.selected = true
		this.isOpen = true
		this.classList.add(this.expandedClass, this.selectedClass)
		this.setExpandedAria()
		// Don't fire tabOpened during init - let the IntersectionObserver handle it
	} else {
		// Only set collapsed height if not on mobile
		if (!this.isMobile()) {
			this.content.style.height = this.collapsedHeight
		}
		this.classList.add(this.collapsedClass)
		this.setCollapsedAria()
	}
		this.content.removeAttribute('hidden')
	}

		transitionendEventName() {
			let i,
				el = document.createElement('div'),
				transitions = {
					'transition': 'transitionend',
					'OTransition': 'otransitionend',
					'MozTransition': 'transitionend',
					'WebkitTransition': 'webkitTransitionEnd'
				}

			for (i in transitions) {
				if (transitions.hasOwnProperty(i) && el.style[i] !== undefined) {
					return transitions[i]
				}
			}
		}

		expand() {
			const resetHeight = (ev) => {
				if (ev.target !== this.content) return
				this.content.removeEventListener(this.transitionendevent, bindEvent)

				if (!this.isOpen) return

				requestAnimationFrame(() => {
					this.content.style.transition = '0'
					this.content.style.height = 'auto'

					requestAnimationFrame(() => {
						this.content.style.height = null
						this.content.style.transition = null

						this.setExpandedAria()
						this.classList.add(this.expandedClass)
						this.trySetTabIndex(this.content, 0)

						this.fire("tabOpened")
						window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this)
					})
				})
			}

			const bindEvent = resetHeight.bind(this)
			this.content.addEventListener(this.transitionendevent, bindEvent)

			this.isOpen = true
			this.classList.remove(this.collapsedClass)
			this.content.style.height = this.content.scrollHeight + "px"
		}

		collapse() {
			const endTransition = (ev) => {
				if (ev.target !== this.content) return
				this.content.removeEventListener(this.transitionendevent, bindEvent)

				if (this.isOpen) return

				this.fire("elementClosed")
				window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_CLOSED`, this)
				this.setCollapsedAria()
				this.classList.add(this.collapsedClass)
				this.trySetTabIndex(this.content, -1)
			}

			const bindEvent = endTransition.bind(this)
			this.content.addEventListener(this.transitionendevent, bindEvent)

			this.isOpen = false
			this.classList.remove(this.expandedClass)

			requestAnimationFrame(() => {
				this.content.style.transition = '0'
				this.content.style.height = this.content.scrollHeight + "px"


				requestAnimationFrame(() => {
					this.content.style.transition = null
					this.content.style.height = this.collapsedHeight
				})
			})
		}

	open() {
		this.selected = true
		this.classList.add(this.selectedClass)
		this.fire("elementSelected")
		window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_SELECTED`, this)
		
		// Only expand if not on mobile (768px and below)
		if (!this.isMobile()) {
			this.expand()
		} else {
			// On mobile, set state without expanding but fire events immediately
			this.isOpen = true
			this.setExpandedAria()
			this.classList.add(this.expandedClass)
			this.classList.remove(this.collapsedClass)
			this.trySetTabIndex(this.content, 0)
			
			// Fire the tabOpened event immediately since there's no transition
			this.fire("tabOpened")
			window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_OPENED`, this)
		}
		
		this.setAttribute('open', true)

		if (this.oneAtATime) {
			const parent = this.closest('[data-collapsible-parent]')
			if( parent ) {
				const allItems = parent.querySelectorAll('collapsible-tab')
				if (allItems.length) {
					allItems.forEach(item => {
						if (item !== this && item.selected) {
							item.close()
						}
					})
				}
			}
		}
	}

	close() {
		this.selected = false
		this.classList.remove(this.selectedClass)
		this.fire("elementUnselected")
		window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_UNSELECTED`, this)
		
		// Only collapse if not on mobile (768px and below)
		if (!this.isMobile()) {
			this.collapse()
		} else {
			// On mobile, set state without collapsing but fire events immediately
			this.isOpen = false
			this.setCollapsedAria()
			this.classList.add(this.collapsedClass)
			this.classList.remove(this.expandedClass)
			this.trySetTabIndex(this.content, -1)
			
			// Fire the elementClosed event immediately since there's no transition
			this.fire("elementClosed")
			window.FoxThemeEvents.emit(`ON_COLLAPSIBLE_TAB_CLOSED`, this)
		}
		
		this.removeAttribute('open')
	}

	toggle(event) {
		// Only prevent default if trigger is not inside a link
		if(event && !this.trigger.closest('a')) {
			event.preventDefault()
		}

		if (this.selected) {
			if ( this.canCloseAll ) {
				this.close()
			} else {
				const parent = this.closest('[data-collapsible-parent]')
				if( parent ) {
					const allItems = parent.querySelectorAll('collapsible-tab')
					allItems.forEach(item => {
						if (item !== this && item.selected) { // If has other selected then close this.
							this.close()
							return true
						}
					})
				}
			}
		} else {
			this.open()
		}
	}

	isMobile() {
		return window.innerWidth <= 768
	}

	trySetTabIndex(el, index) {
		const tappableElements = el.querySelectorAll(this.defaultElements)
		if (tappableElements) {
			tappableElements.forEach(e => {
				e.setAttribute('tabindex', index)
			})
		}
	}

		setExpandedAria() {
			this.trigger.setAttribute('aria-expanded', 'true')
			this.content.setAttribute('aria-hidden', 'false')
		}

		setCollapsedAria(el) {
			this.trigger.setAttribute('aria-expanded', 'false')
			this.content.setAttribute('aria-hidden', 'true')
		}

	attachEvents() {
		this.trigger.addEventListener("click", event => this.toggle(event))
	}

	attachResizeListener() {
		// Debounced resize handler
		let resizeTimeout
		this.handleResize = () => {
			clearTimeout(resizeTimeout)
			resizeTimeout = setTimeout(() => {
				this.onResize()
			}, 150)
		}
		window.addEventListener('resize', this.handleResize)
	}

	onResize() {
		const isMobile = this.isMobile()
		const wasMobile = this.lastIsMobile !== undefined ? this.lastIsMobile : null
		
		// Only adjust if we've crossed the mobile/desktop threshold
		if (wasMobile !== null && isMobile !== wasMobile) {
			this.lastIsMobile = isMobile
			
			if (isMobile) {
				// Switching to mobile - remove all inline height and transition styles
				this.content.style.height = ''
				this.content.style.transition = ''
				
				// Make sure content is visible if this tab is selected/open
				if (this.isOpen || this.selected) {
					this.classList.add(this.expandedClass)
					this.classList.remove(this.collapsedClass)
				}
			} else {
				// Switching to desktop - restore proper collapse/expand behavior
				requestAnimationFrame(() => {
					// Disable transition temporarily to avoid weird animations
					this.content.style.transition = '0'
					
					// Sync the isOpen state with selected state to ensure consistency
					const shouldBeOpen = this.selected || this.getAttribute('open') === 'true'
					this.isOpen = shouldBeOpen
					
					if (shouldBeOpen) {
						// Tab is open/selected - set to auto height
						this.content.style.height = 'auto'
						this.classList.add(this.expandedClass)
						this.classList.remove(this.collapsedClass)
						this.setExpandedAria()
					} else {
						// Tab is closed - set to collapsed height
						this.content.style.height = this.collapsedHeight
						this.classList.add(this.collapsedClass)
						this.classList.remove(this.expandedClass)
						this.setCollapsedAria()
					}
					
					// Re-enable transition after a frame
					requestAnimationFrame(() => {
						this.content.style.transition = ''
					})
				})
			}
		} else if (wasMobile === null) {
			// Initialize the state tracker
			this.lastIsMobile = isMobile
		}
	}

		setDefaultData() {
			this.events = {
				'elementSelected': [],
				'tabOpened': [],
				'elementUnselected': [],
				'elementClosed': []
			}
			this.transitionendevent = this.transitionendEventName()
			this.expandedClass = "is-expanded"
			this.selectedClass = "is-selected"
			this.collapsedClass = "is-collapsed"
			this.trigger = this.querySelector('[data-trigger]')
			this.content = this.querySelector('[data-content]')
			this.collapsedHeight = '0px'
			this.defaultElements = ['a', 'button', 'input:not(.focus-none)', '[data-trigger]']
			this.oneAtATime = true
			if (this.dataset.oneOpen) {
				this.oneAtATime = this.dataset.oneOpen === 'true'
			}

			// Whether keep at least an item opened.
			this.canCloseAll = ( ! this.dataset.canCloseAll || this.dataset.canCloseAll === 'true' )
		}

		fire(eventName) {
			let callbacks = this.events[eventName] || []
			for (let i = 0; i < callbacks.length; i++) {
				callbacks[i](this)
			}
		}

		on(eventName, cb) {
			if (!this.events[eventName]) return
			this.events[eventName].push(cb)
		}

	destroy() {
		this.trigger && this.trigger.removeEventListener("click", event => this.toggle(event))
		if (this.handleResize) {
			window.removeEventListener('resize', this.handleResize)
		}
		this.content && this.content.removeAttribute('aria-hidden')
		if (this.content) this.content.style.height = 'auto'
		this.classList.remove(this.expandedClass, this.collapsedClass)
		this.removeAttribute('open')
	}
	}

	customElements.define('collapsible-tab', CollapsibleTab)
}
